<template>
  <div class="password-input">
    <bb-input
      :type="revealPassword ? 'text' : 'password'"
      :name="name"
      :label="passwordInputLabel"
      :data-vv-as="translations.password"
      :value="value"
      @input="handleInput"
      v-validate="'required'"
    />
    <bb-button
      v-show="!errors.has(name)"
      @click="revealPassword = !revealPassword"
      noBackground
      icon-color="gray-70"
      display="square"
      size="sm"
      class="view-icon"
      :icon="revealPassword ? 'ui-eye-outline' : 'ui-eye'"
    />
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  data () {
    return {
      revealPassword: false,
      translations: {
        password: this.$gettext('Password')
      }
    }
  },
  props: {
    value: {
      default: ''
    },
    label: {
      default: ''
    },
    name: {
      default: 'password'
    },
    hideBorder: {
      default: true
    }
  },
  methods: {
    handleInput (value) {
      this.$emit('input', value)
    }
  },
  computed: {
    passwordInputLabel () {
      return this.label || this.translations.password
    }
  }
}
</script>

<style lang="scss">
.password-input {
  position: relative;

  .view-icon {
    position: absolute;
    right: 0;
    top: 40px;
  }
}
</style>
